import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  makeStyles,
  Radio,
  NativeSelect,
  withStyles,
  InputBase,
  CardHeader,
} from "@material-ui/core";
import { palette, useStylesGlobal } from "configurations/styles/theme";
import { formasPago } from "views/facturacion/Forms/typeVoucher";
import MultiplePayments from "../Buttons/MultiplePayments";
import tableStyle from "configurations/styles/table";
import DeletePaymentBtn from "../Buttons/DeletePaymentBtn";
import bigDecimal from "js-big-decimal";
import AssignmentIcon from "@material-ui/icons/Assignment";
import TableDataSimplePag from "widgets/Tables/TableDataSimplePag";
import TableDataSimple from "widgets/Tables/TableDataSimple";
import { useStylesApp } from "hooks/useStyles";
import { use } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    margin: theme.spacing(1),
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    boxShadow: "5px 3px 3px #aaaaaa",
    borderRadius: "8px",
    borderWidth: "2px",
  },
  formControl: {
    marginTop: theme.spacing(0),
    minWidth: 120,
  },
  radio: {
    display: "-webkit-box",
    marginTop: "0px",
  },
  radioLable: {
    color: palette.primary.main,
    display: "flex",
  },
  radioButton: {
    marginTop: "0px",
    paddingTop: "0px",
  },
  divForm: {
    marginBottom: "0%",
    textAlign: "justify",
    color: theme.palette.text.primary,
  },
  divInput: {
    marginBottom: "1%",
    paddingRight: "1%",
    //paddingLeft: '0.5%',
    textAlign: "justify",
  },
  divSelect: {
    width: "100%",
  },
  divButton: {
    paddingLeft: "3%",
    paddingRight: "3%",
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 999,
    color: palette.primary.main,
  },
  haedClient: {
    backgroundColor: palette.primary.main,
    width: "10%",
    marginBottom: "2%",
    display: "flex",
    flexWrap: "wrap",
    marginBottom: "1%",
    borderStyle: "solid",
    borderBottomWidth: "5px",
    borderRadius: "8px",
  },
}));

const BootstrapInput = withStyles((theme) => ({
  root: {
    "label + &": {
      marginTop: theme.spacing(0),
    },
  },
  input: {
    borderRadius: 4,
    //position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #ced4da",
    fontSize: 16,
    padding: "10px 26px 10px 12px",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
    "&:focus": {
      borderRadius: 4,
      borderColor: "#80bdff",
      boxShadow: "0 0 0 0.2rem rgba(0,123,255,.25)",
    },
  },
}))(InputBase);

const PaymentMethods = ({ totals, pagos, setPagos, productsDetalle }) => {
  const classes = useStyles();
  const classesGlobales = useStylesGlobal();
  const [isOne, setIsOne] = useState("U");
  const [emptyPlazo, setEmptyPlazo] = useState(true);
  const [pago, setPago] = useState({
    codigo: "01",
    descripcion: "",
    valor: totals.totalFacturaConDescuento,
  });
  const [viewPago, setViewPago] = useState(1);
  const columns = [
    {
      title: "Forma pago",
      field: `codigo`,
      cellStyle: tableStyle.cellTable,
      width: "10%",
    },
    {
      title: "Valor",
      field: "valor",
      cellStyle: tableStyle.cellTable,
      width: "30%",
    },
    {
      title: "Eliminar",
      cellStyle: tableStyle.cellTable,
      width: "10%",
      render: (rowData) => (
        <DeletePaymentBtn
          data={rowData}
          pagos={pagos}
          setPagos={setPagos}
          viewPago={viewPago}
          setViewPago={setViewPago}
        />
      ),
    },
  ];
  const [update, setUpdate] = useState(1);
  const classesApp = useStylesApp();

  const handleChangeCheck = (event) => {
    let totalFacturaConDescuento = Number(
      bigDecimal.add(totals.totalFacturaConDescuento, totals.totalPropina),
    );
    if (totalFacturaConDescuento > 0) {
      if (event.target.value) {
        setIsOne(event.target.value);
        setPago({ ...pago, valor: totalFacturaConDescuento });
      } else {
        setIsOne(event.target.value);
      }
    } else {
      alert("No tiene detalle/s ingresado/s");
    }
  };

  const hadleChangePago = (event) => {
    const next = {
      ...pago,
      [event.target.name]: event.target.value, // value ya es string
    };
    setPago(next);
    setPagos([next]);
  };

  const handleChange = (event) => {
    event.preventDefault();
    const next = { ...pago, [event.target.name]: event.target.value };

    setPago(next);
    setPagos([next]);
    if (event.target.name === "plazo" && event.target.value.toString() !== "") {
      setEmptyPlazo(true);
    } else if (
      event.target.name === "plazo" &&
      event.target.value.toString() === ""
    ) {
      setEmptyPlazo(false);
    }
  };

  useEffect(
    () => {
      const total = bigDecimal.add(
        totals.totalFacturaConDescuento,
        totals.totalPropina,
      );
      if (isOne === "U") {
        if (pagos.length !== 0) {
          setPago({
            ...pago,
            ["valor"]: total,
            ["codigo"]: pagos[0].codigo,
          });
        }
        //setPago({...pago,['valor']:bigDecimal.round(bigDecimal.add(totals.totalFacturaConDescuento,totals.totalPropina),2,bigDecimal.RoundingModes.HALF_UP)})
        setPago((prev) => {
          const next = { ...prev, valor: total };
          setPagos([next]); // sincroniza pagos con el mismo objeto "next"
          return next;
        });
      } else if (pagos.length === 1) {
        setPagos([]);
      }
      if (productsDetalle.length > 1) {
        //setPago({...pago,['valor']:bigDecimal.round(bigDecimal.add(totals.totalFacturaConDescuento,totals.totalPropina),2,bigDecimal.RoundingModes.HALF_UP)})
        setPago({
          ...pago,
          ["valor"]: total,
        });
      }
    }, //[isOne,totals.totalFacturaConDescuento])
    [
      isOne,
      productsDetalle,
      totals.totalFacturaConDescuento,
      totals.totalPropina,
    ],
  );

  return (
    <Fragment>
      <div className={classesGlobales.itemContainer}>
        <Grid container xs={12} md={12} justify="center">
          <CardHeader
            className={classesGlobales.cabecera}
            title={"Forma de Pago"}
            avatar={<AssignmentIcon></AssignmentIcon>}
          />
        </Grid>
        <Grid container spacing={1} className={classesGlobales.containerForm}>
          <Grid container justify="center">
            <FormControl component="fieldset" className={classes.formControl}>
              <FormLabel
                component="legend"
                className={classesGlobales.titleCard}
              >
                {" "}
                <strong> Cantidad de pagos de la factura</strong>{" "}
              </FormLabel>
              <RadioGroup
                aria-label="datosCliente"
                name="isOne"
                value={isOne}
                onChange={handleChangeCheck}
                className={classes.radio}
                required
              >
                <FormControlLabel
                  value="U"
                  control={
                    <Radio color="primary" className={classes.radioButton} />
                  }
                  label="Uno"
                  labelPlacement="start"
                  className={classes.radioLable}
                />
                <FormControlLabel
                  value="V"
                  control={
                    <Radio color="primary" className={classes.radioButton} />
                  }
                  label="Varios"
                  labelPlacement="start"
                  className={classes.radioLable}
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {isOne === "U" ? (
            <Fragment>
              <Grid
                container
                spacing={1}
                className={classesGlobales.containerForm}
              >
                <Grid item xs={12} md={2} className={classes.divForm}>
                  <label>
                    Forma: <font color={palette.error.main}>*</font>
                  </label>
                </Grid>
                <Grid item xs={12} md={4}>
                  <FormControl className={classes.divSelect}>
                    <NativeSelect
                      name="codigo"
                      value={pago.codigo}
                      onChange={hadleChangePago}
                      input={<BootstrapInput />}
                    >
                      <option aria-label="None" disabled>
                        --Seleccione--
                      </option>
                      {formasPago.map((pago) => (
                        <option key={pago.CODIGO} value={pago.CODIGO}>
                          {pago.CODIGO} - {pago.NOMBRE}
                        </option>
                      ))}
                    </NativeSelect>
                  </FormControl>
                </Grid>

                {pago.codigo == 99 ? (
                  <Fragment>
                    <Grid item xs={12} md={2} className={classes.divForm}>
                      <label>
                        Descripción: <font color={palette.error.main}>*</font>
                      </label>
                    </Grid>
                    <Grid item xs={12} md={4} className={classes.divInput}>
                      <input
                        type="text"
                        placeholder="Ej. Otros"
                        name="descripcion"
                        value={pago.descripcion}
                        onChange={handleChange}
                        autoComplete="off"
                        className={
                          pago
                            ? pago.descripcion
                              ? "form-control is-valid"
                              : "form-control"
                            : "form-control"
                        }
                      />
                    </Grid>
                  </Fragment>
                ) : null}

                <Grid item xs={12} md={2} className={classes.divForm}>
                  <label>
                    Total: <font color={palette.error.main}>*</font>
                  </label>
                </Grid>
                <Grid item xs={12} md={4}>
                  <input
                    type="text"
                    placeholder="Ej. 300"
                    disabled
                    name="total_"
                    value={pago.valor}
                    //onChange={event=> setPago({...pago,[event.target.name]:event.target.value})}
                    autoComplete="off"
                    className={
                      pago
                        ? pago.valor
                          ? "form-control is-valid"
                          : "form-control"
                        : "form-control"
                    }
                  />
                </Grid>
              </Grid>
            </Fragment>
          ) : (
            <Grid item xs={12} md={12}>
              <MultiplePayments
                pagos={pagos}
                setPagos={setPagos}
                viewPago={viewPago}
                setViewPago={setViewPago}
                totals={totals}
              />
              {pagos.length > 0 ? (
                <Grid item xs={12} md={12}>
                  {viewPago === 1 ? (
                    <TableDataSimplePag
                      title=""
                      columns={columns}
                      data={pagos}
                      buscar={false}
                    />
                  ) : (
                    <TableDataSimple
                      title=""
                      columns={columns}
                      data={pagos}
                      buscar={false}
                    />
                  )}
                </Grid>
              ) : null}
            </Grid>
          )}
        </Grid>
      </div>
    </Fragment>
  );
};

export default PaymentMethods;
